import { useState, ChangeEvent, useRef } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import HeatmapCombinedSensorList from "../create/CreatePeopleHeatmapCharts/HeatmapCombinedSensorList";
import DashboardCreateSelectSensorModal from "components/dashboard/create/modal/SelectDevices";
import { RemoveIcon } from "components/common";
import { HeatmapLayout } from "components/dashboard/create/CreatePeopleHeatmapCharts";
import { showErrorAlert } from "utils/alert";

const UpdateHeatmapPanel = ({ onChange, panel, deviceList }: any) => {
    const fileRef = useRef<any>(null);
    const [heatmapLayout] = useState(1);
    const [selectSensorModal, setSelectSensorModal] = useState<any>(null);
    const sensorType = "People Count Sensor";

    const combinedSensorList = (panel?.attributes || []).map((attr: any) => {
        return (deviceList || []).find(
            (device: any) => device.gatewayId === attr.gateway_id
        );
    });

    const handleChangeFormData = (field: string, value: any) => {
        if (typeof onChange === "function") {
            onChange(field, value);
        }
    };

    const handleChangeSensorList = (sensors: any) => {
        const formatedSensors = sensors.map((sensor: any) => {
            if (!sensor?.deviceId) {
                return {};
            }

            return {
                gateway_id: sensor.gatewayId,
            };
        });

        handleChangeFormData("attributes", formatedSensors);
    };

    const removeFileUpload = () => {
        fileRef.current.value = "";
        handleChangeFormData("image", null);
        handleChangeFormData("image_uuid", null);
    };

    const handleChangeUploadImage = (e: ChangeEvent<any>) => {
        const file = e.target.files?.[0];

        const fileSize = (file?.size || 0) / 1024 / 1024;
        if (fileSize > 1) {
            showErrorAlert({
                message: "Image size should be less than 1MB",
            });
            removeFileUpload();
            return;
        }

        if (!file?.name) {
            return removeFileUpload();
        }

        handleChangeFormData("image", file);
        handleChangeFormData("image_uuid", file?.name);
    };

    return (
        <div>
            <Form.Group>
                <Form.Label>Chart Name</Form.Label>
                <Form.Control
                    name="name"
                    type="text"
                    defaultValue={""}
                    placeholder=""
                    value={panel?.name}
                    onChange={(event) =>
                        handleChangeFormData("name", event.target.value)
                    }
                />
            </Form.Group>

            <Form.Group className="mt-4">
                <Form.Label>Heatmap Layout</Form.Label>
                <div style={{ display: "flex" }}>
                    <HeatmapLayout selected={heatmapLayout === 1} />
                </div>
            </Form.Group>

            <Form.Group className="mt-4">
                <Form.Label>Upload image for selected layout</Form.Label>
                <div>
                    {!panel?.image_uuid && (
                        <Button
                            variant="primary"
                            onClick={() => {
                                fileRef.current.click();
                            }}
                        >
                            Upload Layout Image
                        </Button>
                    )}

                    <Form.File
                        ref={fileRef}
                        className="d-none"
                        accept=".jpeg,.jpg,.png"
                        onChange={handleChangeUploadImage}
                    />

                    {panel?.image_uuid && (
                        <div
                            style={{
                                padding: "14px 16px",
                                gap: 14,
                                minWidth: 179,
                                borderRadius: 5,
                                display: "inline-flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                background: "#394662",
                            }}
                        >
                            <div>{panel.image?.name}</div>
                            <div>
                                <Button
                                    variant="link"
                                    className="p-0 text-decoration-none d-flex"
                                    onClick={() => removeFileUpload()}
                                >
                                    <RemoveIcon />
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </Form.Group>

            <div
                className="mt-4"
                style={{ borderTop: "1px solid #3E4B67" }}
            ></div>

            <Form.Group className="mt-4">
                <Form.Label>Sensors for combined heatmap chart</Form.Label>
                <HeatmapCombinedSensorList
                    onSelectSensor={(modal: any) => {
                        setSelectSensorModal(modal);
                    }}
                    onChange={(sensors: any) => handleChangeSensorList(sensors)}
                    sensors={combinedSensorList}
                />
            </Form.Group>

            <DashboardCreateSelectSensorModal
                multipleSelection={!!selectSensorModal?.multipleSelection}
                show={!!selectSensorModal}
                deviceType="Sensor"
                onHide={() => setSelectSensorModal(null)}
                values={selectSensorModal?.selectedSensors}
                excludeDevices={selectSensorModal?.excludeDevices || []}
                sensorTypes={[sensorType]}
                onSave={(event, data) => {
                    selectSensorModal.handler(data);
                    setSelectSensorModal(null);
                }}
            />
        </div>
    );
};

export default UpdateHeatmapPanel;
